module.exports = __webpack_public_path__ + "menu_1_pc.6f1c9b4f.png";